import React , {useContext} from "react";
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Poppers from "@material-ui/core/Popper";
import {MenuItem, MenuList, Grow, Paper, ClickAwayListener, Hidden} from "@material-ui/core/";
// @material-ui/icons
import {Person} from "@material-ui/icons/";
// core components
import Button from "../../components/CustomButtons/Button.js";

import styles from "../../assets/jss/material-dashboard-react/components/headerLinksStyle.js";
import AuthContext from "../../Context/auth/AuthContext"
import MensajeContext from "../../Context/Mensajes/MensajeContext";


const useStyles = makeStyles(styles);

export default function AdminNavbarLinks() {
  const { cerrarSesion  } = useContext(AuthContext)
  
  const { quitarMensajes } = useContext(MensajeContext)
  const classes = useStyles();
  
  const [openProfile, setOpenProfile] = React.useState(null);


  const handleClickProfile = event => {
    if (openProfile && openProfile.contains(event.target)) {
      setOpenProfile(null);
    } else {
      setOpenProfile(event.currentTarget);
    }
  };
  const handleCloseProfile = () => {
    setOpenProfile(null);
  };
  return (
    <div>
    
      <div className={classes.manager}>
        <Button
          color={window.innerWidth > 959 ? "transparent" : "white"}
          justIcon={window.innerWidth > 959}
          simple={!(window.innerWidth > 959)}
          aria-owns={openProfile ? "profile-menu-list-grow" : null}
          aria-haspopup="true"
          onClick={handleClickProfile}
          className={classes.buttonLink}
        >
          <Person className={classes.icons} />
          <Hidden mdUp implementation="css">
            <p className={classes.linkText}>Profile</p>
          </Hidden>
        </Button>
        <Poppers
          open={Boolean(openProfile)}
          anchorEl={openProfile}
          transition
          disablePortal
          className={
            classNames({ [classes.popperClose]: !openProfile }) +
            " " +
            classes.popperNav
          }
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              id="profile-menu-list-grow"
              style={{
                transformOrigin:
                  placement === "bottom" ? "center top" : "center bottom"
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleCloseProfile}>
                  <MenuList role="menu">
                 
                    <MenuItem
                      onClick={()=>{
                        handleCloseProfile()
                        
                          cerrarSesion()
                          quitarMensajes()
                      }}
                      className={classes.dropdownItem}
                    >
                      Cerrar Sesión
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Poppers>
      </div>
    </div>
  );
}
